import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import { BsExclamationLg } from "react-icons/bs";
import { FaCircleXmark } from "react-icons/fa6";
import { formatNumberWithCommas } from "../../../utils/commonUtils";
import {
  cancelManualTransfer,
  fetchManualTransfer,
} from "../../../redux/slices/manualTransferSlice";
import { pushNotifyUser } from "../../../redux/slices/pushSlice";
import { toast } from "react-toastify";

export default function CancelLaundryManualTransfer({
  id,
  name,
  amount,
  user_id,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const status = useSelector((state) => state.payment?.status);

  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelManualTransfer(id));
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Your Laundry payment of ₦ ${amount} has been canceled. Please contact support for details.`,
          click: "USER",
        };
        dispatch(pushNotifyUser(pushNote));
        await dispatch(fetchManualTransfer());
        toast.success(res.payload.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while cancelling.");
    }
    setShowCancelModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <FaCircleXmark className="text-red-600 text-2xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center overflow-auto">
            <div className="relative w-auto mx-auto max-w-3xl bg-white p-12 rounded-lg shadow-lg">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-3 right-2.5 text-gray-400 hover:text-gray-900"
              >
                <FaTimes className="text-xl" />
              </button>
              <div className="text-center mb-4">
                <h1 className="text-2xl font-medium text-gray-800">
                  Are you sure?
                </h1>
                <p>Do you really want to cancel this payment?</p>
              </div>
              <div className="flex justify-center items-center my-4">
                <BsExclamationLg className="text-gray-500 text-3xl" />
              </div>
              <div className="flex gap-4 justify-center mt-4">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="text-sm font-semibold text-gray-500 bg-gray-100 py-2 px-4 rounded-md"
                >
                  No, Keep It
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    setShowCancelModal(true);
                  }}
                  className="text-sm font-semibold text-white bg-red-600 py-2 px-4 rounded-md"
                >
                  Yes, Cancel It
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}

      {showCancelModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center overflow-auto">
            <div className="relative w-auto max-w-5xl mx-auto bg-white p-12 rounded-lg shadow-lg">
              <button
                onClick={() => setShowCancelModal(false)}
                className="absolute top-3 right-2.5 text-gray-400 hover:text-gray-900"
              >
                <FaTimes className="text-xl" />
              </button>
              <div className="text-center mb-4">
                <h1 className="text-2xl font-medium text-gray-800">
                  Cancel Manual Transfer
                </h1>
                <p>Do you really want to cancel this Laundry payment?</p>
              </div>
              <div className="flex justify-center items-center my-4">
                <BsExclamationLg className="text-gray-500 text-3xl" />
              </div>
              <div className="flex flex-col gap-4 justify-center items-center">
                <div className="text-left">
                  <p>
                    <span className="text-gray-400">User name:</span>{" "}
                    <strong>{name}</strong>
                  </p>
                  <p>
                    <span className="text-gray-400">Amount:</span>{" "}
                    <strong>&#8358;{formatNumberWithCommas(amount)}</strong>
                  </p>
                </div>
                <div className="flex gap-4 mt-4">
                  <button
                    onClick={() => setShowCancelModal(false)}
                    className="text-sm font-semibold text-gray-500 bg-gray-100 py-2 px-4 rounded-md"
                  >
                    Back
                  </button>
                  <button
                    className="flex gap-2 items-center text-sm font-semibold text-white bg-red-600 py-2 px-4 rounded-md"
                    disabled={status === "loading"}
                    onClick={handleCancel}
                  >
                    {status === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Cancelling...
                      </>
                    ) : (
                      <>
                        <FaTimes />
                        Cancel Transfer
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}
    </>
  );
}
